import { createFileRoute, redirect } from '@tanstack/react-router'
import * as React from 'react'
import { resolveSession } from '../features/auth/session'
import { ProfitScreen } from '../features/profit'
import { canSeeProfit, type ProfitSearch, parseProfitSearch } from '../features/profit/api'

export const Route = createFileRoute('/profit')({
  validateSearch: (raw: Record<string, unknown>): ProfitSearch => parseProfitSearch(raw),
  // Manager and billing only (COST_READERS). Cover and tech are sent home; the API 403s them regardless. An unknown
  // session (API unreachable) is not a role, so it is not redirected: the screen shows what failed instead.
  beforeLoad: async ({ context }) => {
    const session = await resolveSession(context.queryClient)
    if (session.kind === 'signed_in' && !canSeeProfit(session.me.role)) throw redirect({ to: '/' })
  },
  component: function ProfitRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const onSearch = React.useCallback(
      (patch: Partial<ProfitSearch>) =>
        void navigate({ search: (prev: ProfitSearch) => parseProfitSearch({ ...prev, ...patch }), replace: true }),
      [navigate],
    )
    return <ProfitScreen search={search} onSearch={onSearch} />
  },
})
